//Permet d'ajouter les variables globales d'environnement.
type WindowEnv = Partial<{
    REACT_APP_MODE: string;
    REACT_APP_NUMBER_ELEMENT_TABLE: number;
    REACT_APP_URLAPI: string;
}>;

declare global {
    interface Window {
        env: WindowEnv;
    }
}

// Permet de définir les variables utiles
type EnvType = {
    // REACT_APP_MODE : pour voir la valeur de l'env de l'app (dev, stage...)
    REACT_APP_MODE: string;
    // Nombre d'éléments à afficher par page dans un tableau
    REACT_APP_NUMBER_ELEMENT_TABLE: number;
    // url vers l'api espace élu
    REACT_APP_URLAPI: string;
};
//Export d'env avec les attributs utiles
export const env: EnvType = { ...process.env, ...(globalThis.window?.env ?? {}) } as EnvType;
